import { useInput } from 'react-admin';
import {
    EditBase,
    Form,
    SaveButton,
    Toolbar,
    useEditContext,
} from 'react-admin';
import { Box, Card, CardContent } from '@mui/material';

import { ResourceNotFound } from '@/components/misc/ResourceNotFound';
import { Lead } from '@/types';
import { LeadAside } from './LeadAside';
import { LeadInputs } from './LeadInputs';
import {
    LeadNextStepsEditor,
    stepsFromRecord,
    type NextStepDraft,
} from './LeadNextStepsEditor';

const NextStepsInput = () => {
    const { field } = useInput({ source: 'next_steps', defaultValue: [] });
    const value: NextStepDraft[] = Array.isArray(field.value) ? field.value : [];
    return (
        <LeadNextStepsEditor
            value={value}
            onChange={next => field.onChange(next)}
        />
    );
};

export const LeadEdit = () => (
    <EditBase
        mutationMode="pessimistic"
        redirect="show"
        queryOptions={{ meta: { includes: 'lead_next_steps' } }}
    >
        <LeadEditContent />
    </EditBase>
);

const LeadEditContent = () => {
    const { isPending, record, error } = useEditContext<Lead>();
    if (isPending) return null;
    if (error || !record) {
        return (
            <ResourceNotFound
                resourceLabel="Lead"
                listPath="/leads"
                listLabel="Back to leads"
            />
        );
    }
    return (
        <Box mt={2} display="flex" flexWrap="wrap">
            <LeadAside link="show" />
            <Box flex="1">
                <Form
                    defaultValues={{
                        next_steps: stepsFromRecord(record.next_steps),
                    }}
                >
                    <Card>
                        <CardContent>
                            <LeadInputs />
                            <NextStepsInput />
                        </CardContent>
                        <Toolbar>
                            <SaveButton />
                        </Toolbar>
                    </Card>
                </Form>
            </Box>
        </Box>
    );
};
